<template>
    <div>
        <h1 class="page-title">Commande de voucher Ogloba</h1>
    </div>
    <div class="card">
        <DataTable
            :value="tableData"
            :rows="rows"
            :paginator="true"
            :loading="isLoading"
            :rowsPerPageOptions="rowsPerPageOptions"
            lazy
            @page="onPaginate"
            :currentPage="currentPage"
            :totalRecords="totalRecords"
        >
            <template #header>
                <div class="search-container">
                    <router-link
                        class="group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600"
                        to="/admin/catalogue/create-ogloba-order"
                    >
                        Commander un voucher
                    </router-link>
                </div>
            </template>
            <div class="card-body pt-0">
                <Column field="createdAt" header="Date"/>
                <Column field="voucherRef" header="Référence voucher"/>
                <Column field="productName" header="Nom du produit" />
                <Column field="faceValue" header="Valeur faciale" >
                <template #body="slotProps">
                    {{slotProps.data.faceValue + ' €'}}
                </template>
                </Column>
                <Column  field="state" header="Etat du voucher" >
                <template #body="slotProps">
                    {{getLabelStatus(slotProps.data.state)}}
                </template>
                </Column>
                <Column field="createdBy" header="Utilisateur"/>
                <Column headerStyle="width: 12em;">
                    <template #header>
                        <div>Actions</div>
                    </template>
                    <template #body="slotProps">
                        <Button
                            v-if="slotProps.data.giftCardUrl !== ''"
                            size="small"
                            icon="pi pi-download"
                            class="p-button-success"
                            style="margin-right: 0.5em"
                            title="Télécharger le voucher"
                            @click="downloadVoucher(slotProps.data.uuid, slotProps.data.voucherRef)"
                        />
                    </template>
                </Column>
            </div>
            <template #empty>Aucun résultat trouvé.</template>
        </DataTable>
    </div>
</template>

<script lang="ts" setup>
import Column from "primevue/column";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import { ref, onMounted } from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";

const page = ref < number > (1);
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
let rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const vouchers = Array<Document>();
let tableData = ref<Array<Document>>(vouchers);
let currentPage = ref<number>(0);
let totalRecords = ref<number>(0);


onMounted(async () => {
    await populateDatatable(rows.value, page.value);
});

const populateDatatable = async (itemsPerPage: number, page: number) => {
     await fetchData(itemsPerPage, page);
};

async function fetchData(
    itemsPerPage: number,
    page: number
) {
    const params = {
        itemsPerPage: itemsPerPage,
        page: page,
    }
    try {
        const { data } = await ApiService.get('admin/get-ogloba-voucher-created-by-admin', {
            headers: { Accept: 'application/ld+json' },
            params: params
        });
        totalRecords.value = data.data['hydra:totalItems'];
        tableData.value=[];
        data.data['hydra:member'].forEach((item) => {
            tableData.value.push(item);
        });
    } catch (error) {
        swal.error('An error occurred while fetching vouchers.');
    }
    isLoading.value = false;
}

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    isLoading.value =true;
    await populateDatatable(e.rows, e.page + 1);
};


function getLabelStatus(status: string): string {
    switch (status) {
        case 'CONFIRMED':
            return 'Confirmé';
        case 'RESERVED':
            return 'Créé';
        case 'SENDED':
            return 'Envoyé';
        case 'READY':
            return 'Prêt';
        default:
            return status;
    }
}

async function downloadVoucher(voucherUuid, voucherRef) {
    try {
        ApiService.get(`/customer/order/document/${voucherUuid}`,
            {responseType: 'blob'}
        ).then(response => {
            const blob = new Blob([response.data], {type: 'application/pdf'})
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = voucherRef
            link.click()
            URL.revokeObjectURL(link.href)
        })
    } catch (error) {
        swal.error();
    }
}

</script>
